import { FC } from 'react';
import ItemImage from '../../components/ItemImage/ItemImage';
import ItemImageUpload from '../../components/ItemImageUpload/ItemImageUpload';
import { IItemImagesProps } from '../../types';
import { RESTRICTION_ACCESS } from 'src/constants/integrations';
import { TOOLTIP_POSITION } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import { IFile } from 'src/view/components/Controls/Upload/types';
import IntegrationManager from 'src/view/components/IntegrationManager/IntegrationManager';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';

type TProps = Pick<IItemImagesProps, 'images' | 'disabled' | 'deleteImage'>;

interface IProps extends TProps {
  addMode: boolean;
  editMode: boolean;
  imageValid: boolean;
  imagesRestrictionAccess: RESTRICTION_ACCESS | undefined;
  onChangeAddMode: (file: IFile) => void;
  onChangeEditMode: () => void;
  onUploadImage: (image: string) => void;
}

const ItemImagesList: FC<IProps> = ({ addMode, editMode, imageValid, disabled, ...props }: IProps): JSX.Element => {
  return (
    <ScrollableBlock
      showScrollbar
      direction="horizontal"
      scrollbarSize="small"
      className="items-images__scroll-wrapper"
      scrollClassName="items-images__scroll"
    >
      {/* add image button(drag zone) */}
      <IntegrationManager
        setting={props.imagesRestrictionAccess}
        withTooltip={!disabled}
        tooltipOptions={{ gapTop: -5, wrapperClassName: 'h-100', position: TOOLTIP_POSITION.PORTAL }}
      >
        <ItemImageUpload
          image=""
          onChange={props.onChangeAddMode}
          uploadImage={props.onUploadImage}
          validation={imageValid}
          disabled={disabled}
          addMode={!addMode}
          className={!addMode ? 'full-height justify-content-center' : 'full-width'}
        />
      </IntegrationManager>
      {/*  images list  */}
      {!addMode ? (
        <ul className="d-flex flex-row align-items-center full-height">
          {props.images &&
            props.images.map((_image, index) => (
              <ItemImage
                key={_image}
                id={_image}
                image={_image}
                imagesLength={props.images?.length}
                index={index}
                editMode={editMode}
                disabled={disabled}
                posRestrictions={props.imagesRestrictionAccess}
                changeEditMode={props.onChangeEditMode}
                deleteImage={props.deleteImage}
              />
            ))}
        </ul>
      ) : null}
    </ScrollableBlock>
  );
};

export default ItemImagesList;
